<div fxLayout="row wrap">

    <div fxFlex="100" fxFlex.gt-sm="60" class="p-1">
        <app-sales-summary></app-sales-summary>
    </div>

    <div fxFlex="100" fxFlex.gt-sm="40" class="p-1">
        <app-montly-sales></app-montly-sales>  
    </div>  

    <div fxFlex="100" class="p-1">
        <app-daily-views-stats></app-daily-views-stats>
    </div>

    <div fxFlex="100" fxFlex.gt-sm="50" class="p-1">
        <app-most-viewed-products></app-most-viewed-products>  
    </div>  

    <div fxFlex="100" fxFlex.gt-sm="50" class="p-1">
        <app-transactions></app-transactions> 
    </div>  
   
    <div fxFlex="100" class="p-1">
        <app-refunds></app-refunds>
    </div>
    

</div>